import React from 'react';

import {Modal} from 'reactstrap';

interface Props {
  show: boolean;
  imageURL: string;
  toggle: () => void;
}

export function ZoomedImage({show, imageURL, toggle}: Props): JSX.Element {
  return (
    <Modal
      keyboard={true}
      contentClassName="w-auto"
      centered={true}
      isOpen={show}
      toggle={toggle}
      style={styles.modal}
    >
      <img src={imageURL} style={styles.image} className="img-fluid" />
      <button className="btn" style={styles.closeButton} onClick={toggle}>
        <i className="fas fa-times" />
      </button>
    </Modal>
  );
}
const styles = {
  modal: {
    position: 'relative' as const,
    maxWidth: '95vw',
    width: 'auto',
    justifyContent: 'center',
  },
  image: {
    width: 'auto',
    padding: '4px',
  },
  closeButton: {
    backgroundColor: 'white',
    position: 'absolute' as const,
    top: -10,
    right: -10,
    width: 25,
    height: 25,
    padding: 0,
  },
};
